export default __webpack_public_path__ + "static/media/250.68075082.gif";